import { Link as RouterLink } from 'react-router'

import { useDocumentOrigin } from '../legal/useDocumentOrigin'
import { DisclaimerCaption, DisclaimerLink } from './styled'

const DISCLAIMER = 'AI can make mistakes. Using Hey Nic is optional.'

/*
 * The caption under the chat input, opening the in-app AI Disclaimer viewer in
 * the same tab. Shared by the main chat's input footer and the step-by-step
 * advice panel, whose footer shows the caption on its own (there is no input
 * field outside the summary step).
 */
const ChatDisclaimer = ({ className }) => {
  const documentOrigin = useDocumentOrigin()

  return (
    <DisclaimerCaption className={className}>
      {`${DISCLAIMER} `}
      <DisclaimerLink as={RouterLink} to='/ai-disclaimer' state={documentOrigin}>
        AI Disclaimer
      </DisclaimerLink>
    </DisclaimerCaption>
  )
}

export default ChatDisclaimer
